import styled from '@emotion/styled';
import { Popover } from 'antd';
import { isStoreAliasFirst, useStoreNameConfig } from 'hooks/business/store/useStoreName';
import toLowerCase from 'utils/toLowerCase';
import { BlueTag, GreenTag, RedTag, BlackTag } from 'components/styled/tags';
import { platformLabelMap } from 'services/config/platform';
import { CountryFlagIcon } from 'components/CountryFlagIcon';
import { useTranslate } from '@tolgee/react';

const Flex = styled.div`
  display: flex;
  gap: 6px;
  width: 360px;
  align-items: center;
  justify-content: start;
  & + & {
    margin-top: 10px;
  }
`;

const tagMap = {
  SHOPEE: RedTag,
  LAZADA: BlueTag,
  TOKOPEDIA: GreenTag,
  WA_BIZ: GreenTag,
  TIKTOK: BlackTag,
  TIKTOK_US: BlackTag,
  ALIEXPRESS: BlueTag,
  FACEBOOK: BlueTag,
  MERCADO: BlueTag,
  KWAI: BlueTag,
  JOLECT: BlueTag,
} as const;
const Title = styled.div`
  width: 200px;
  font-size: 12px;
  color: var(--fett-text-tertiary);
  background-color: var(--fett-bg-panel);
  max-height: 160px;
  overflow-y: auto;
  word-break: break-all;
  .label {
    color: var(--fett-text-secondary);
  }
`;
const StoreRow = ({
  store,
}: {
  store: Omit<Assistant.Group['stores'][number], 'tunnelAccountId'>;
}) => {
  const { storeId, storeName, externalType = 'SHOPEE', alias, region } = store;
  const { config } = useStoreNameConfig();
  const { t } = useTranslate();
  const isAlisaFirst = (
    platform: General.PlatformUpperCaseTunnel,
    region: General.UpperCaseRegion,
  ) => isStoreAliasFirst(config, platform, region);
  const name = isAlisaFirst(externalType, region) && alias ? alias : storeName;
  const popoverNode = (
    <Title>
      <div className="label">{t('ViewShops.店铺名称')}</div>
      <div>{storeName}</div>
      <div className="label">{t('ViewShops.店铺别名')}</div>
      <div>{alias}</div>
    </Title>
  );

  const PlatformTag = tagMap[externalType];
  return (
    <Popover
      placement="top"
      key={storeId}
      content={popoverNode}
      visible={alias ? undefined : false}
    >
      <Flex>
        {PlatformTag && <PlatformTag>{platformLabelMap[toLowerCase(externalType)]}</PlatformTag>}
        <CountryFlagIcon region={region} />
        <span>{name}</span>
      </Flex>
    </Popover>
  );
};

export default StoreRow;
